export default "__VITE_ASSET__n2BEuuC0__";